import { CheckCircle2Icon, ZapIcon, ShieldCheckIcon, type LucideIcon } from 'lucide-react';

export interface PricingRow {
  content: string;
  value: string;
}

export const pricingRows: PricingRow[] = [
  { content: 'Colección Completa (6 Tomos)', value: '59,90€' },
  { content: 'Los 5 Bonos Estratégicos', value: '59,50€' },
  { content: 'Acceso de por vida', value: '∞' }
];

export interface PricingTrustItem {
  icon: LucideIcon;
  label: string;
}

export const pricingTrustItems: PricingTrustItem[] = [
  { icon: CheckCircle2Icon, label: 'Pago único' },
  { icon: ZapIcon, label: 'Acceso inmediato' },
  { icon: ShieldCheckIcon, label: 'Garantía 7 días' }
];

export const pricingIncludes: string[] = [
  '60 ejercicios técnicos y tácticos con esquemas.',
  '48 sesiones de planificación + 10 para situaciones imprevistas.',
  'Calendario propuesto de 40 semanas.',
  '18 rutinas de preparación física.',
  'Correcciones, variantes y registros imprimibles.'
];
